import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { DirectoryEntryEditInfo } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.state';

@Pipe({
   name: 'directoryInfoLastTimeEdited',
})
export class DirectoryInfoLastTimeEditedPipe implements PipeTransform {
   transform(info: DirectoryEntryEditInfo): Date {
      if (!_.isNil(info?.updatedEntry?.orgupdate) && info?.updatedEntry?.orgupdate?.isValueSet) {
         return info?.updatedEntry?.orgupdate?.value;
      }
      if (!_.isNil(info?.editedEntry?.orgupdate) && info?.editedEntry?.orgupdate?.isValueSet) {
         return info?.editedEntry?.orgupdate?.value;
      }
      if (!_.isNil(info?.originalEntry?.orgupdate) && info?.originalEntry?.orgupdate?.isValueSet) {
         return info?.originalEntry?.orgupdate?.value;
      }
      if (!_.isNil(info?.updatedEntry?.orgcreate)) {
         return info?.updatedEntry?.orgcreate?.value;
      }
      if (!_.isNil(info?.editedEntry?.orgcreate)) {
         return info?.editedEntry?.orgcreate?.value;
      }
      if (!_.isNil(info?.originalEntry?.orgcreate)) {
         return info?.originalEntry?.orgcreate?.value;
      }
      return null;
   }
}
